import { axiosInstance } from '../Config/axios';

const API_URL = `v1/controls/config/areas/`;

// Función para listar las areas (GET)
export const getAreas = async () => {
  try {
    const response = await axiosInstance.get(API_URL);
    return response.data;
  } catch (error) {
    console.error('Error al obtener las áreas:', error);
    throw error;
  }
};

// Obtener un área por código
export const getAreasById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}${id}/`);
    return response.data;
  } catch (error) {
    console.error(`Error al obtener el área con código ${id}:`, error);
    throw error;
  }
};

// Función para crear una nueva área (POST)
export const createArea = async (areaData) => {
  try {
    const response = await axiosInstance.post(API_URL, areaData);
    return response.data;
  } catch (error) {
    console.error('Error al crear un área:', error);
    throw error;
  }
};

// Función para actualizar un área (PUT)
export const updateArea = async (id, areaData) => {
  try {
    const response = await axiosInstance.put(`${API_URL}${id}/`, areaData);
    return response.data;
  } catch (error) {
    console.error('Error al actualizar el área:', error);
    throw error;
  }
};

// Función para eliminar un área (DELETE)
export const deleteArea = async (id) => {
  try {
    await axiosInstance.delete(`${API_URL}${id}/`);
  } catch (error) {
    console.error('Error al eliminar el área:', error);
    throw error;
  }
};